import React from 'react';
import { Row, Col, Tag } from 'antd';

const groups = [
  {
    title: 'Stablecoins & smart contracts',
    items: ['Solidity', 'ERC-20', 'Mint & burn pipelines', 'Supply controllers',
      'Pause / freeze controls', 'Reserve operations', 'Contract security review'],
  },
  {
    title: 'Chains I ship on',
    items: ['EVM', 'Solana', 'Tron', 'Aptos', 'Arbitrum', 'Optimism'],
  },
  {
    title: 'Custody & keys',
    items: ['MPC threshold signing', 'Multisig contracts', 'Key management', 'WBTC infrastructure'],
  },
  {
    title: 'Backend & infrastructure',
    items: ['TypeScript', 'Node.js', 'Go', 'Postgres', 'GraphQL',
      'Microservices', 'Kubernetes', 'Docker', 'AWS'],
  },
];

const tagStyle = {
  fontSize: '13px',
  padding: '4px 12px',
  marginBottom: '8px',
  borderRadius: '14px',
  border: '1px solid #e3ebe7',
  background: '#f5f8f9',
  color: '#33475b',
};

const SkillsProgress = () => (
  <div>
    <h2 className="titleSeparate">What I work with</h2>
    <p style={{ marginBottom: '24px' }}>
      Most of my time goes into issuance systems for regulated tokens, and into the
      operational side of running the same asset across several chains at once.
    </p>
    <Row gutter={[20, 20]}>
      {groups.map((g) => (
        <Col xs={24} sm={24} md={12} key={g.title}>
          <h4 style={{ fontWeight: 600, marginBottom: '12px' }}>{g.title}</h4>
          <div>
            {g.items.map((item) => (
              <Tag key={item} style={tagStyle}>{item}</Tag>
            ))}
          </div>
        </Col>
      ))}
    </Row>
  </div>
);

export default SkillsProgress;
